import { AuditLogRecordType } from '../../interfaces/management/schema.interface';
import { EventMeta } from '../../interfaces/meta.interface';

import SharePoint from './SharePoint';
import SharePointFileOperation from './SharePointFileOperation';
import SharePointSharingOperation from './SharePointSharingOperation';

const records: Partial<{ [key in AuditLogRecordType]: { [key: string]: EventMeta<any> } }> = {
    [AuditLogRecordType.SharePoint]: SharePoint,
    [AuditLogRecordType.SharePointFileOperation]: SharePointFileOperation,
    [AuditLogRecordType.SharePointSharingOperation]: SharePointSharingOperation,
};

export default records;
